import { RcClasses } from '../../../../foundation';
export var RcListItemIconClasses = RcClasses(['alignItemsFlexStart'], 'RcListItemIcon');
